// Inespay exige al menos 7 caracteres. Sin '-': el backend lee la tarifa tras el primer '-'.
export const SubscriptionSubjectPrefix = "Suscripción ";
export const SampleProfileSubjectPrefix = "Cartera Ejemplo ";

export const buildSubscriptionSubject = (userId: number, subscriptionId: number | undefined): string =>
{
    return `${SubscriptionSubjectPrefix}${userId}-${subscriptionId}`;
};

// El backend sustituye "****" por el userId.
export const buildSampleProfileSubject = (subscriptionId: number): string =>
{
    return `${SampleProfileSubjectPrefix}****-${subscriptionId}`;
};
